import React from "react";

export const PermisionsHRRequestsTable = ({ requestsUserPermision }) => {
	return (
		<div>
			<table className="tabla-procesos">
				<tbody>
					{requestsUserPermision.length > 0 ? (
						requestsUserPermision[0].requestsViewPermision.map((el) => (
							<tr className="fila-tabla-cuenstas" key={el}>
								<td className="colTableDocuments1">{el}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
